<script setup>
const props = defineProps({
    headline: { type: String, default: '' },
    body: { type: String, default: '' },
    bodyHtml: { type: String, default: '' },
    actions: { type: Array, default: () => [] },
    dismissable: { type: Boolean, default: true },
    persistent: { type: Boolean, default: false },
});
const open = defineModel('open', { default: true });
const emit = defineEmits(['close']);

const buttonVariant = (v) => (v === 'link' ? { variant: 'link' } : {});
</script>

<template>
    <FragmentsModalShell
        v-model:open="open"
        :headline="headline"
        :dismissable="dismissable"
        :persistent="persistent"
        @close="emit('close')"
    >
        <p v-if="body" class="text-center">{{ body }}</p>
        <div v-else-if="bodyHtml" class="text-center" v-html="bodyHtml" />
        <template v-if="actions.length" #actions>
            <UButton
                v-for="(a, i) in actions"
                :key="i"
                v-bind="buttonVariant(a.variant)"
                @click="emit('close', a.value)"
            >{{ a.label }}</UButton>
        </template>
    </FragmentsModalShell>
</template>
